import { render, staticRenderFns } from "./MenuDetailHeader.vue?vue&type=template&id=37777613"
import script from "./MenuDetailHeader.vue?vue&type=script&lang=js"
export * from "./MenuDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports